import styled, { css } from 'styled-components';

import { Icon, Link } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, Components,
  FontSize,
  FontFamily,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.COMPONENT_TABS;

export const StyledActiveTab = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};

  ${Breakpoints.desktopOnly(css`
    margin: 13px 0 0;
    padding: 30px;
  `)}

`;

export const ActiveTabTitle = styled.h2`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG12, undefined, undefined)};
  margin-bottom: 12px;
  color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};

  ${Breakpoints.mobile(css`
    display: none;
  `)}
`;

export const ComponentWrapper = styled.div`
  width: 100%;
  
  ${Breakpoints.mobile(css`
    padding: 10px 25px 10px;
  `)}
`;

export const ActiveContentOuterContainer = styled.div`
  display: flex;
  padding: 30px;
  border-radius: 5px;
  width: 100%;
`;

export const ComponentIconWrapper = styled.div``;

export const ComponentIcon = styled(Icon)`
  svg {
    fill: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
  }
`;

export const CTAList = styled.ul`
  display: flex;

  ${Breakpoints.desktopOnly(css`
    padding: 25px 0 0;
    gap: 30px;
  `)}

  ${Breakpoints.mobile(css`
    flex-direction: row;
    text-align: center;
    flex-direction: column;
    gap: 15px;
    padding: 15px 0;
  `)}
`;

// this referece to li.cta-button in original template
export const CTAItem = styled.li`
  display: inline-block;
  text-align: center;
`;

// this refers to a.btn in original template
export const CTAButton = styled(Link)`
  display: inline-block;
  line-height: 1.1;
  min-width: 200px;
  padding: 10px 20px;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
  color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
  ${() => getFontStyles(FontFamily.SECONDARY_FONT)};

  &:hover, &:focus {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
  }

  &:focus {
    outline: 2px solid ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    outline-offset: 2px;
  }

  ${Breakpoints.mobile(css`
    display: inline-block;
    min-width: 0;
    width: 85%;
    padding: 10px 20px;
  `)}
`;
